import styles from './style.module.css';

import { ReactNode, useState } from 'react';

type ThisComponentProps = {
    title: ReactNode,
    children: ReactNode,
}

const Submenu = ({title, children} : ThisComponentProps) => {
    const [fixed, setFixed] = useState(
        (localStorage.getItem('_smf') ?? 'true') === 'true'
    );

    const toggle = () => {
        localStorage.setItem('_smf', `${!fixed}`);
        setFixed(!fixed);
    };

    return (
        <aside className={[
            styles.menu, 'submenu',
            fixed ? styles.fixed : '',
            fixed ? 'fixed' : ''
        ].join(' ')}>
            <div className={styles.logoWrap}>
                <a className={styles.logo} href={'/'}/>

                <div className={styles.pin} onClick={toggle}></div>
            </div>

            <div className={styles.title}>
                {title}
            </div>

            {children}
        </aside>
    );
};

export default Submenu;
